<template>
  <div class="mb-2">
    <div>
      <label> Cấu hình trả góp</label>
      <Autosuggest
        :placeholder="`Chương trình trả góp`"
        :model="getInstallmentProgram.installmentProgramName"
        :suggestions="getUniqueInstallmentPrograms()"
        @select="onSelected($event)"
        :state="validate"
        :disabled="disabled"
        @focus.native="handlerFetchInstallmentProgram"
        @click.native="handlerFetchInstallmentProgram"
      />

      <b-form-group class="my-2">
        <b-form-select
          :disabled="isDisabled(getInstallmentProgram, 'monthNo')"
          :options="getInstallmentProgram.monthNo"
          v-model="getInstallmentProgram.installmentProgramMonthNo"
          size="sm"
          value-field="id"
          text-field="name"
          class="select-style"
        >
          <template v-slot:first>
            <b-form-select-option :value="null"
              >Chọn kỳ hạn
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group class="my-2" :disabled="true">
        <b-input
          id="conversion-fee-input"
          type="text"
          size="sm"
          class="input-style"
          v-model="prepayAmount"
          placeholder="Số tiền trả trước"
          :state="validPrepayAmount"
          @input="validateInputPrepayAmount"
          v-mask="currency"
        ></b-input>

        <b-form-invalid-feedback :state="validPrepayAmount">
          {{ errorMessagePrepayAmount }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :disabled="true">
        <b-input-group size="sm" append="%">
          <b-input
            id="prepay-percent-input"
            type="text"
            size="sm"
            class="input-style"
            v-model="getInstallmentProgram.installmentProgramPrepayPercent"
            placeholder="Phần trăm trả trước"
          ></b-input>
        </b-input-group>
      </b-form-group>
      <!-- <b-form-group class="my-2">
        <b-form-select
          :disabled="isDisabled(getInstallmentProgram, 'prepayPercent')"
          :options="getInstallmentProgram.prepayPercent"
          v-model="getInstallmentProgram.installmentProgramPrepayPercent"
          size="sm"
          value-field="id"
          text-field="name"
          class="select-style"
        >
          <template v-slot:first>
            <b-form-select-option :value="null"
              >Chọn phần trăm trả trước</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-form-group> -->
    </div>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { mapGetters } from 'vuex';
import { SET_INSTALLMENT_PROGRAM } from '@/core/services/store/modules/payment/payment-installment.module';
import { currencyMask, unMaskPrice, convertPrice } from '../../../utils/common';

const PAYMENT_TYPE = {
  INSTALLMENT: 4,
};
export default {
  props: {
    totalPrepayAmount: { type: Number, default: 0 },
    item: { type: Object },
    finalAmount: { type: Number, default: 0 },
    paymentType: {
      type: Number,
      required: true,
      default: null,
      validator: (value) => {
        return Object.values(PAYMENT_TYPE).includes(value);
      },
    },
    isInterestZero: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    validate: {
      type: Boolean,
      default: true,
    },
    options: [],
    fetchInstallment: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      prepayAmount: 0,
      validPrepayAmount: null,
      errorMessagePrepayAmount: null,
      currency: currencyMask,
      currentAccountId: null,
    };
  },
  components: {
    Autosuggest,
  },
  computed: {
    ...mapGetters(['getInstallmentProgram']),
  },
  created() {
    this.prepayAmount = this.totalPrepayAmount;
    // this.handlerFetchInstallmentProgram()
  },
  methods: {
    convertPrice,
    async handlerFetchInstallmentProgram() {
      if (this.currentAccountId !== this.item?.paymentRefId) {
        await this.fetchInstallment();
        this.currentAccountId = this.item?.paymentRefId;
      }
    },
    validateInputPrepayAmount() {
      const value = unMaskPrice(
        this.getInstallmentProgram.installmentProgramPrepayAmount,
      );
      if (+value < 0) {
        this.validPrepayAmount = false;
        this.errorMessagePrepayAmount = 'Số tiền trả trước phải lớn hơn 0';
        return;
      }
      this.validPrepayAmount = true;
      this.errorMessagePrepayAmount = null;
    },
    isDisabled(value, type) {
      switch (type) {
        case 'monthNo':
          return this.disabled || !value.monthNo.length;
        case 'prepayPercent':
          return this.disabled || !value.prepayPercent.length;
        default:
          break;
      }
    },
    getUniqueInstallmentPrograms() {
      if (
        !this.getInstallmentProgram.details?.length ||
        !this.item?.paymentRefId
      ) {
        return [];
      }
      const filteredDetails = this.getInstallmentProgram.details.filter(
        (detail) =>
          detail.installmentProgramDetails?.length > 0 &&
          detail.installmentProgramDetails.some(
            (subDetail) => subDetail.installmentId == this.item.paymentRefId,
          ),
      );
      const uniqueMap = filteredDetails.reduce(
        (map, item) => map.set(item.id, item),
        new Map(),
      );
      return Array.from(uniqueMap.values());
    },
    onSelected(selectedItem) {
      const program = selectedItem.item;
      /** Khi select chương trình trả góp thì refresh lại số tháng và phần trăm trả trước*/
      this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
        installmentProgramId: program.id,
        installmentProgramName: program.name,
        monthNo: program.monthNo
          ? program.monthNo.split(',').map(Number)
          : null,
        installmentProgramMonthNo: null,
        installmentProgramPrepayPercent:
          this.getInstallmentProgram.installmentProgramPrepayPercent || 0,
        installmentProgramPrepayAmount:
          convertPrice(this.totalPrepayAmount) || 0,
        prepayPercent: program.prepayPercent
          ? program.prepayPercent.split(',').map(Number)
          : null,
        conversionFeePercent: program.conversionFeePercent,
        conversionFeeMethod: program.conversionFeeMethod,
        details: this.getInstallmentProgram.details,
      });
    },
  },
  watch: {
    // Theo dõi sự thay đổi của số tiền trả trước
    'getInstallmentProgram.installmentProgramPrepayAmount'(newAmountStr) {
      const amount = +unMaskPrice(newAmountStr);
      if (amount === 0) {
        this.getInstallmentProgram.installmentProgramPrepayPercent = 100;
      }
      // Trường hợp 2: Nếu số tiền > 0 và tổng tiền hợp lệ, tính toán bình thường
      else if (this.finalAmount && this.finalAmount > 0 && amount > 0) {
        const percentage = (amount / this.finalAmount) * 100;
        this.getInstallmentProgram.installmentProgramPrepayPercent =
          percentage.toFixed(2);
      }
      // Trường hợp 3 (còn lại): Các trường hợp không hợp lệ khác (amount < 0, finalAmount không hợp lệ)
      else {
        this.getInstallmentProgram.installmentProgramPrepayPercent = 0;
      }
    },
    totalPrepayAmount(newAmountStr) {
      this.prepayAmount = this.convertPrice(newAmountStr);
      this.getInstallmentProgram.installmentProgramPrepayAmount =
        this.convertPrice(newAmountStr || 0);
    },
  },
};
</script>
